import type { FC, PropsWithChildren } from "react";
import clsx from "clsx";

interface FormLayoutProps {
	className?: string;
}

export const RegistrationFormLayout: FC<PropsWithChildren<FormLayoutProps>> = ({ children, className }) => {
	return (
		<div
			className={clsx(
				"bg-brand-light border-brand-dark/10 mx-auto rounded-2xl border p-6 sm:p-10 lg:p-20",
				"shadow-[0_6px_8px_-6px_rgba(74,68,100,0.10),0_8px_16px_-6px_rgba(74,68,100,0.06)]",
				className
			)}
		>
			{children}
		</div>
	);
};
